/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trigger_WebhookInputs */

const cs_trigger_webhook = /** @type {(inputs: Trigger_WebhookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Webhook`)
};

const en_trigger_webhook = /** @type {(inputs: Trigger_WebhookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Webhook`)
};

/**
* | output |
* | --- |
* | "Webhook" |
*
* @param {Trigger_WebhookInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const trigger_webhook = /** @type {((inputs?: Trigger_WebhookInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trigger_WebhookInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_trigger_webhook(inputs)
	return cs_trigger_webhook(inputs)
});